export default {
  setBusy({ commit }) {
    commit("SET_BUSY", true);
  },
  clearBusy({ commit }) {
    commit("SET_BUSY", false);
  },
  clearBusyWithDelay({ commit }, delay) {
    delay = !delay || delay <= 0 ? 500 : delay;
    setTimeout(function() {
      commit("SET_BUSY", false);
    }, delay);
  },
  setBaseApiUrl({ commit }, baseApiUrl) {
    commit("SET_API_URL", baseApiUrl);
  },
  setSystemErrorMessage({ commit }, message) {
    commit("SET_ERROR_MESSAGE", message);
  },
  setSystemError({ commit }, error) {
    commit("SET_ERROR", error);
  },
};
